module.exports = __webpack_public_path__ + "static/media/mobile-login-background.aa1fe515.png";